module.exports = __webpack_public_path__ + "img/user-icon.840f4469.svg";